import { colors, general } from '@/styles'

export const menuStyles = {
  list: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '100%',
  },
  menuList: {
    display: general.block,
    borderRadius: '10px',

    '& div[role=button]': {
      padding: 0,
      borderRadius: '10px',
      marginBottom: '4px',
      color: colors.textSecondary,
    },
  },
  button: {
    '&:hover': {
      backgroundColor: 'customColors.backgroundPrimary',
    },
  },
  logoutModalBodyWrapper: {
    display: 'flex',
    alignItems: 'flex-start',
    flexWrap: 'nowrap',
    justifyContent: 'space-between',
  },
  buttonsWrapper: {
    display: 'flex',
    gap: '15px',
    alignItems: 'center',
  },
  menuListWrapper: {
    padding: '0 10px',
    display: general.block,
  },
  menuActiveList: {
    backgroundColor: 'rgba(186, 141, 91, 0.1)',

    '& .MuiListItemIcon-root, span': {
      color: `${colors.mainPrimary} !important`,
    },
  },
  menuButtons: {
    minHeight: 48,
    px: 2.5,
  },
  menuJustify: {
    justifyContent: general.center,
  },
  gap: {
    gap: '17px',

    span: {
      color: 'red',
    },
  },
}
